import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'

export class TouchActions extends UcoastEl {
    static htmlSelector = 'touch-actions'
    contentToggles: NodeListOf<HTMLElement>
    contentItems: NodeListOf<HTMLElement>
    closeButtons: NodeListOf<HTMLButtonElement>
    mainGrid: HTMLElement
    currentIndex: number = 0
    constructor() {
        super()
        this.mainGrid = q.rs('[data-uc-touch-actions-main-grid]', this)
        this.contentItems = q.rl('[data-uc-touch-actions-content-item]', this)
        this.contentToggles = q.rl('[data-uc-touch-actions-touchpoint]', this)
        this.closeButtons = q.rl('[data-uc-touch-actions-close]', this)
    }

    override connectedCallback() {
        super.connectedCallback()
        this.contentToggles.forEach(toggle => {
            toggle.addEventListener('click', (e) => {
                e.preventDefault()
                const index = parseInt(q.ra(toggle, 'data-uc-touch-actions-touchpoint'))
                this.setCurrentIndex(index)
                this.open()
            })
        })
        this.closeButtons.forEach(button => {
            button.addEventListener('click', (e) => {
                e.preventDefault()
                this.close()
            })
        })
    }
    setCurrentIndex(index: number) {
        this.currentIndex = index
    }
    close() {
        this.contentItems.forEach(el => {
           el.classList.remove('active')
        });
    }
    open() {
        let opened = false
        this.contentItems.forEach(el => {
            const index = parseInt(q.ra(el, 'data-uc-touch-actions-content-item'))
            //console.log({index, currentIndex: this.currentIndex})
            if (index === this.currentIndex) {
                el.classList.add('active')
                // console.log({el, scrollHeight: el.scrollHeight})
                // const scrollHeight: number = parseInt(el.scrollHeight.toFixed(0))
                // if (window.innerWidth < 750) {
                //     this.mainGrid.style.minHeight = `calc(var(--ax) * ${(scrollHeight + 48)})`
                // }

                opened = true
            } else {
                el.classList.remove('active')
            }
        })
        if (!opened) {
            this.mainGrid.removeAttribute('style')
        }

    }
}
